import { connect } from "react-redux";
import Result, {
  RESULT_TYPE,
  defaultProps,
} from "components/ecosystems/Result";
import resultMore from "actions/resultMore";
import focusFirstNewItemDone from "actions/focusFirstNewItemDone";
import queryChange from "actions/queryChange";
import { filterMounted } from "actions";
import { deepMerge } from "utils/object";
import { getQueryFilterName } from "utils/filter";

function getResultType(state) {
  const hasRecords = state.result.records && state.result.records.length > 0;
  if (state.result.type === RESULT_TYPE.REDIRECT) {
    return RESULT_TYPE.REDIRECT;
  }

  if (!hasRecords && state.search.error) {
    return RESULT_TYPE.NO_RESPONSE;
  }

  if (!hasRecords) {
    return state.result.changedFilterType === "query"
      ? RESULT_TYPE.NO_RESULT_KEYWORD
      : RESULT_TYPE.NO_RESULT_FILTER;
  }

  return RESULT_TYPE.RESULT;
}

const mapStateToProps = (state) => {
  return {
    itemsPerPage: state.result.itemsPerPage,
    loading: state.search && state.search.loading,
    loadingMore: state.result && state.result.loadingMore,
    offset: state.result.offset,
    focusFirstNewItem: state.result.focusFirstNewItem,
    records: state.result.records,
    redirect: state.result.redirect,
    totalCount: state.result.totalCount,
    type: getResultType(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onResultMore: (count) => dispatch(resultMore(count)),
    onFocusFirstNewItemDone: () => dispatch(focusFirstNewItemDone()),
    onFilterChange: (name, value) => {
      dispatch(queryChange(name, value));
    },
    onQueryChange: (name, value, valueBeforeSuggest) => {
      dispatch(queryChange(name, value, valueBeforeSuggest));
    },
    noResultKeyword: {
      inputSearch: {
        onMountStateChange: (name, mounted) => {
          dispatch(filterMounted(name, mounted));
        },
      },
    },
  };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  let props = Object.assign({}, ownProps, dispatchProps, stateProps);

  props = deepMerge({}, defaultProps, props, {
    noResultKeyword: {
      inputSearch: {
        name: getQueryFilterName(),
      },
    },
  });
  return props;
};

const ResultContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Result);

export default ResultContainer;
